import React, { useEffect, useState } from 'react';

// Sub-component for individual circular progress
const CircularProgress = ({ percentage, label }) => {
  const [offset, setOffset] = useState(0);
  const radius = 40;
  const circumference = 2 * Math.PI * radius;

  // Animate the circle filling up on load
  useEffect(() => {
    const targetOffset = circumference - (percentage / 100) * circumference;
    // Set a slight delay for a staggered animation effect
    const timeout = setTimeout(() => setOffset(targetOffset), 100); 
    return () => clearTimeout(timeout);
  }, [percentage, circumference]);

  return (
    <div className="flex flex-col items-center group">
      <div className="relative w-40 h-40 flex items-center justify-center mb-6">
        
        {/* SVG Canvas */}
        <svg className="w-full h-full transform -rotate-90" viewBox="0 0 100 100">
          {/* Background Track Circle */}
          <circle
            cx="50"
            cy="50"
            r={radius}
            fill="transparent"
            stroke="rgba(255,255,255,0.05)" // Very faint white
            strokeWidth="8"
          />
          {/* Animated Glowing Progress Circle */}
          <circle
            cx="50"
            cy="50"
            r={radius}
            fill="transparent"
            stroke="#39FF14" // Electric Green
            strokeWidth="8"
            strokeDasharray={circumference}
            strokeDashoffset={offset || circumference} // Start empty, animate to value
            strokeLinecap="round"
            className="transition-all duration-1000 ease-out drop-shadow-[0_0_8px_rgba(57,255,20,0.6)] group-hover:drop-shadow-[0_0_15px_rgba(57,255,20,1)]"
          />
        </svg>
        
        {/* Centered Percentage Text */}
        <div className="absolute flex items-baseline">
          <span className="text-4xl font-bold text-white">{percentage}</span>
          <span className="text-xl text-electric-green ml-1">%</span>
        </div>
        
      </div>
      
      {/* Label under the circle */}
      <h4 className="text-gray-300 font-medium tracking-wide text-center group-hover:text-white transition-colors">{label}</h4>
    </div>
  );
};


// Main Section Component
const AnalyticsCircles = () => {
  const stats = [
    { percent: 72, label: "Best Performance" },
    { percent: 90, label: "Advanced Analytics" },
    { percent: 77, label: "Data Management" },
    { percent: 65, label: "Advanced Solution" }
  ];

  return (
    <section className="py-24 px-6 relative bg-[#1A1F29]/30 border-y border-white/5">
      <div className="max-w-7xl mx-auto">
        
        {/* Header Text */}
        <div className="text-center mb-20">
          <span className="text-electric-green font-bold text-sm uppercase tracking-widest drop-shadow-[0_0_8px_rgba(57,255,20,0.5)]">
            Analytics and Solutions
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-white mt-4 max-w-3xl mx-auto leading-tight">
            Data Analytics, Content & IT Managed Service.
          </h2>
        </div>

        {/* Circular Grids */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-12 md:gap-8">
          {stats.map((stat, index) => (
            <CircularProgress 
              key={index} 
              percentage={stat.percent} 
              label={stat.label} 
            />
          ))}
        </div>

      </div>
    </section>
  );
};

export default AnalyticsCircles;